<script>
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import propIdMixin from './prop-id-mixin';
import contentParserMixin from './content-parser-mixin';

export default {
	name: 'PostView',
	mixins: [propIdMixin, contentDataLoaderMixin, staticDataLoaderMixin, contentParserMixin],
	data() {
		return {
			contentType: 'posts',
			containerClass: 'post-container',
			contentClass: 'post-content',
		};
	},
	updated() {
		this.updateImages();
	},
	created() {
		this.updateImages();
		this.$emit('alt-background', false);
	},
	methods: {
		updateImages() {
			const media = this.findInMedia(this.getContentById('posts', this.id).file_id);
			if (media) {
				this.$root.$emit('updateCoverImages', [media.original_name]);
			}
		},
	},
};
</script>

<style src="@/styles/views/PostView/PostView.less" lang="less"></style>
<style src="@/styles/views/ContentParserStyles/ContentParserStyles.less" lang="less"></style>
